
import { useStore } from "vuex";
import { UploadOutlined } from "@ant-design/icons-vue";
import { defineComponent, reactive, ref, watch, computed } from "vue";

import router from "@/router";
import { debounce } from "@/utils/debounce";
import GoBack from '../components/Back.vue';
import Header from "@/components/Header.vue";
import { getFromStore } from "../utils/store";
import { ToastService } from "@/services/toast";
import { toastError } from "../utils/toastError";
import { allergiesService } from "@/services/allergies";
import { IAllergy, IAllergyResponse } from "@/types/allergies";

export default defineComponent({
  props: {
    paramId: {
      type: String,
    },
  },
  components: {
    GoBack,
    Header,
    UploadOutlined,
  },
  setup(props) {
    const toast = new ToastService();
    const loading = ref<boolean>(false);

    let iData: string;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const symptomsList = [
      "Fever",
      "Vomit",
      "Nausea",
      "Headache",
      "Stomach Pain",
    ];

    const store = useStore();

    const imageUrl = ref<string>(
      process.env.VUE_APP_API_URL + "/allergies/upload-image"
    );
    const headers = ref({
      Authorization: `Bearer ${getFromStore("token")}`,
    });

    const formState = reactive<Record<string, any>>({});

    function handleChange(info: any) {
      if (info.file.status === "done") {
        iData = info.file.response;
      } else if (info.file.status === "error") {
        toast.error(info.file.response.error ?? "error uploading image.");
      }
    }

    const onFinish = (values: IAllergy) => {
      loading.value = true;
      if (props.paramId) {
        allergiesService
          .updateAllergy({ ...values, image: iData }, +props.paramId)
          .then(() => {
            toast.success("Allergy updated successfully...");
            setTimeout(() => router.push("/dashboard"), 1000);
          })
          .catch((err) => {
            toastError(err);
          })
          .finally(() => loading.value = false);
      } else {
        allergiesService
          .addAllergy({ ...values, image: iData })
          .then(() => {
            toast.success("Allergy created successfully...");
            setTimeout(() => router.push("/dashboard"), 1000);
          })
          .catch((err) => {
            toastError(err);
          })
          .finally(() => loading.value = false);
      }
    };

    const matchedAllergy = computed(() => {
      return store.state.allergies.allAllergies.filter(
        (allergy: IAllergyResponse) => {
          if (props.paramId) {
            if (allergy.id === +props.paramId) {
              return allergy;
            }
          }
        }
      );
    });

    watch(
      formState,
      debounce(() => {
        if (formState.name) {
          store.dispatch("allergies/searchAllergies", formState.name);
          const allNamedAllergies = store.state.allergies.allAllergies.map(
            (allergy: IAllergyResponse) => allergy.name
          );
          if (allNamedAllergies.includes(formState.name.toLowerCase())) {
            toast.warning("this allergy is already added!");
          }
        }
      })
    );

    return {
      loading,
      symptomsList,
      formState,
      currentAllergy: matchedAllergy.value[0] as IAllergyResponse,
      imageUrl,
      headers,
      formItemLayout,
      onFinish,
      handleChange,
    };
  },
});
